var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.037,
    height: 8.947,
    viewBox: "0 0 5.037 8.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-down-chevron-4695656",
    d: "M218.994,210.169a.559.559,0,0,0-.791,0l-3.522,3.522-3.522-3.522a.56.56,0,0,0-.791.791l3.917,3.917a.559.559,0,0,0,.791,0l3.917-3.917a.559.559,0,0,0,0-.791Z",
    transform: "translate(215.042 -210.211) rotate(90)",
    fill: "#d3ff9a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.471b6b914be4a30130df5318aa09f9dd.svg";
export { ForwardRef as ReactComponent };